import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  podcast: "",
  isPlaying: false,
  url: "",
  title: "",
  type: "",
};

const playerSlice = createSlice({
  name: "player",
  initialState: initialState,
  reducers: {
    getPodcast(state, payload) {
      state.podcast = payload.payload.response;
    },
    setAudioPlayer(state, payload) {
      state.url = payload.payload.url;
      state.title = payload.payload.title;
      state.isPlaying = payload.payload.isPlaying;
      state.type = payload.payload.type;
    },
    getInHouse(state, payload) {
      state.inHouse = payload.payload.response;
    },
    getInHouseChannels(state, payload) {
      state.inHouseChannels = payload.payload.response;
    },
    getSingleChannel(state, payload) {
      state.singleChannel = payload.payload.response;
    },
    getClientEpisodes(state, payload) {
      state.clientEpisodes = payload.payload.response;
    },
    isPlaying(state, payload) {
      state.isPlaying = payload.payload;
    },
    alert(state, action) {
      state.error = action.payload;
    },
    reset(state, payload) {
      state.url = "";
      state.title = "";
      state.isPlaying = false;
      state.type = "";
    },
  },
});

export default playerSlice.reducer;
export const playerActions = playerSlice.actions;
